const config = {
  basePath: '/' + (process.env.REACT_APP_URL_PREFIX || ''),
  apiURL: `${process.env.PUBLIC_URL}/api`,
};

export default config;
